/*eslint-disable*/
import React, { useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import { Grid, Button, Chip } from '@mui/material'
import { useTranslation } from 'react-i18next'

import { EMPTY_PLACE_HOLDER } from '../../../../constants/general'

// components

// hooks

// styles
import styles from './groupInfo.module.scss'

const editStyle = {
  backgroundColor: '#eb1700',
  '&:hover': {
    backgroundColor: '#CC1400',
  },
  '&:disabled': {
    backgroundColor: '#665A47',
  },
  '&:focus': {
    backgroundColor: '#CC1400',
  },
}

const cancelStyle = {
  backgroundColor: 'rgba(98, 81, 55, 0.1)',
  '&:hover': {
    backgroundColor: 'rgba(102,90,71, 0.20)',
  },
  '&:focus': {
    backgroundColor: 'rgba(112, 99, 79, 0.1)',
  },
}

const GroupInfo = ({ group }) => {
  const { t } = useTranslation()
  const { id, displayName, stats, description } = group || {}
  const navigate = useNavigate()
  const handleViewEditMembers = () => {
    navigate(`/edit-members/${id}`)
  }
  const totalMembersCount = stats?.totalMemberCount
  return (
    <div className={styles.contentContainer}>
      <di className={styles.titleContainer}>
        <h1>{t('view-group-name')}</h1>
        <span className={styles.displayNameStyle}>{displayName}</span>
      </di>
      <div className={`${styles.textContainer} ${styles.firstElement}`}>
        <div className={styles.label}>{t('view-group-ID')}</div>
        <div className={styles.value}>{id || EMPTY_PLACE_HOLDER}</div>
      </div>
      <div className={styles.textContainer}>
        <div className={`${styles.label} ${styles.flexStartElement}`}>
          {t('view-group-total-members')}
        </div>
        <div className={styles.gapElement}>
          <div className={`${styles.value} ${styles.flexElement}`}>
            {totalMembersCount || EMPTY_PLACE_HOLDER}
          </div>
          <Button
            className={styles.addBtn}
            variant="contained"
            onClick={handleViewEditMembers}
          >
            {t('view-group-manage-members-button')}
          </Button>
        </div>
      </div>
      <div className={`${styles.textContainer} ${styles.lastElement}`}>
        <div className={styles.label}>{t('view-group-description')}</div>
        <div className={styles.value}>{description || EMPTY_PLACE_HOLDER}</div>
      </div>
      <Grid style={{ marginTop: '40px' }}>
        <Button
          onClick={() => navigate(`/edit-group/${group.id}`)}
          className="primary-btn"
          variant="contained"
          disableElevation={true}
          sx={{ ...editStyle, marginTop: '20px' }}
        >
          {t('view-group-edit-button')}
        </Button>
        <Button
          onClick={() => navigate('/search-group')}
          className="secondary-btn"
          variant="contained"
          disableElevation={true}
          sx={{ ...cancelStyle, marginTop: '20px', color: '#000' }}
        >
          {t('view-group-back-button')}
        </Button>
      </Grid>
    </div>
  )
}

export default GroupInfo
